import { Link } from "react-router-dom";

import imgPeople from "../../../assets/image/addProducts/people1.jpg";
import { HeaderImage } from "../../../components/layout/shared/header_image/HeaderImage";
import { Page } from "../../../shared/ui/page";
import { useUserFormScreen } from "../model/useUserFormScreen";
import { UserFormSkeleton } from "./UserFormSkeleton";
import { UserFormAlerts } from "./UserFormAlerts";
import { UserPersonalInfoForm } from "./UserPersonalInfoForm";
import { FormCard, MainContainer } from "./UserFormWidget.styles";

export const UserFormWidget = () => {
  const {
    canEditAllFields,
    formik,
    getFieldStatus,
    handleCancel,
    handleSelectSupplier,
    handleSubmit,
    handleToggleSupplier,
    isEdit,
    loadError,
    loadingFormData,
    loadingRoles,
    loadingSuppliers,
    loadingUser,
    roleOptions,
    selectedRoleOption,
    selectedSupplierOption,
    showManagementActions,
    supplierOptions,
  } = useUserFormScreen();

  const formTitle = isEdit ? (showManagementActions ? "Editar usuario" : "Mi perfil") : "Crear usuario";
  const formDescription = isEdit
    ? showManagementActions
      ? "Aquí puedes actualizar la información del usuario."
      : "Actualiza tu información personal."
    : "Crea un usuario nuevo con la configuración requerida.";

  const pageHeader = showManagementActions
    ? {
        title: "Usuarios",
        breadcrumbs: [
          { title: <Link to="/admin">Inicio</Link> },
          { title: <Link to="/admin/management">Usuarios</Link> },
          { title: formTitle },
        ],
      }
    : {
        title: "Mi perfil",
        breadcrumbs: [
          { title: <Link to="/admin">Inicio</Link> },
          { title: "Mi perfil" },
        ],
      };

  const personalInfoContent = (
    <UserPersonalInfoForm
      canEditAllFields={canEditAllFields}
      formik={formik}
      formTitle={showManagementActions ? "Configuración del usuario" : "Información personal"}
      formDescription={formDescription}
      getFieldStatus={getFieldStatus}
      handleCancel={handleCancel}
      handleSelectSupplier={handleSelectSupplier}
      handleSubmit={handleSubmit}
      handleToggleSupplier={handleToggleSupplier}
      isEdit={isEdit}
      loadingRoles={loadingRoles}
      loadingSuppliers={loadingSuppliers}
      loadingUser={loadingUser}
      roleOptions={roleOptions}
      selectedRoleOption={selectedRoleOption}
      selectedSupplierOption={selectedSupplierOption}
      showLockedHint={isEdit && !canEditAllFields}
      showManagementActions={showManagementActions}
      supplierOptions={supplierOptions}
    />
  );

  return (
    <Page
      showPageHeader
      header={pageHeader}
      contentPadding="0"
      minHeight="auto"
    >
      <MainContainer>
        <HeaderImage
          imageHeader={imgPeople}
          titleHeader={isEdit ? (showManagementActions ? "Editar usuario" : "Mi perfil") : "Registra tus usuarios"}
          bannerIcon=""
          backgroundIconColor=""
          bannerInformation=""
          backgroundInformationColor=""
        />

        {loadingFormData ? (
          <UserFormSkeleton
            isEdit={isEdit}
            showLockedHint={isEdit && !canEditAllFields}
          />
        ) : (
          <>
            <UserFormAlerts handleCancel={handleCancel} loadError={loadError} />

            {!loadError && <FormCard>{personalInfoContent}</FormCard>}
          </>
        )}
      </MainContainer>
    </Page>
  );
};

export default UserFormWidget;
